// Curated list of public-facing internal routes offered when picking a
// destination for a custom button in the site editor. Grouped so the
// dashboard/authenticated-owner pages are easy to spot in the dropdown.
export const INTERNAL_ROUTE_GROUPS = [
  {
    label: 'Public Pages',
    routes: [
      { value: '/', label: 'Home' },
      { value: '/marketing', label: 'Public Site (Home / Landing)' },
      { value: '/directory', label: 'Directory' },
      { value: '/auction', label: 'Auction Store' },
      { value: '/dealbin', label: 'Deal Bin' },
      { value: '/donate', label: 'Donate' },
      { value: '/store', label: 'Online Store' },
      { value: '/loyalty', label: 'Loyalty' },
      { value: '/coupons', label: 'Coupons' },
      { value: '/events', label: 'Events' },
      { value: '/dating', label: 'Dating' },
      { value: '/dating/rules', label: 'Dating Rules' },
      { value: '/community', label: 'Community' },
      { value: '/psa', label: 'PSA' },
      { value: '/groups', label: 'Groups' },
      { value: '/news', label: 'News / RSS' },
      { value: '/leaderboard', label: 'Leaderboard' },
      { value: '/funds', label: 'Funds' },
      { value: '/resale', label: 'Ticket Resale Marketplace' },
    ],
  },
  {
    label: 'Auth Pages',
    routes: [
      { value: '/signup', label: 'Sign Up' },
      { value: '/login', label: 'Log In' },
      { value: '/forgot-password', label: 'Forgot Password' },
    ],
  },
  {
    label: 'Dashboard Pages',
    routes: [
      { value: '/business-dashboard', label: 'Business Dashboard' },
      { value: '/business/manage', label: 'Manage Listings' },
      { value: '/business/upgrade', label: 'Upgrade / Plans' },
      { value: '/business/auctions', label: 'Manage Auctions' },
      { value: '/business/coupons', label: 'My Coupons' },
      { value: '/business/loyalty', label: 'My Loyalty' },
      { value: '/business/reviews', label: 'Business Reviews' },
      { value: '/marketing/landing', label: 'Landing Page Builder' },
      { value: '/marketing/contacts', label: 'Owner Contacts' },
      { value: '/marketing/surveys', label: 'Survey Builder' },
      { value: '/marketing/campaigns', label: 'Campaigns' },
      { value: '/marketing/auto-responder', label: 'Auto-Responder' },
      { value: '/groups/mine', label: 'My Groups (Organizer)' },
      { value: '/my/tickets', label: 'My Tickets' },
      { value: '/profile', label: 'My Profile' },
      { value: '/profile/interests', label: 'My Interests' },
    ],
  },
  {
    label: 'Legal',
    routes: [
      { value: '/terms', label: 'Terms' },
      { value: '/privacy', label: 'Privacy' },
    ],
  },
];

// Flat list — kept for lookups (e.g. label-by-value) and backwards compat.
export const INTERNAL_ROUTES = INTERNAL_ROUTE_GROUPS.flatMap(g => g.routes);

// Human-readable labels for pageKey rows in the admin editor.
export const SITE_PAGE_LABELS = {
  home: 'Public Site (Home / Landing)',
  directory: 'Directory',
  events: 'Events',
  donate: 'Donate',
  dating: 'Dating',
  rss: 'RSS Feed',
  leaderboard: 'Leaderboard',
  terms: 'Terms',
  privacy: 'Privacy',
  auction: 'Auction Store',
  store: 'Online Store',
  loyalty: 'Loyalty',
  community: 'Community',
  psa: 'PSA',
  upgrade: 'Upgrade Plans',
};

export const SECTION_TYPES = [
  { value: 'heading', label: 'Heading' },
  { value: 'richtext', label: 'Text block' },
  { value: 'image', label: 'Single image' },
  { value: 'gallery', label: 'Image gallery' },
  { value: 'banner', label: 'Banner (image + CTA)' },
  { value: 'buttons', label: 'Button row' },
  { value: 'video', label: 'YouTube video' },
  { value: 'divider', label: 'Divider' },
];
